export enum AppUrls {
    PORTAL_URL = "https://portal.kif.info.pl/",
    ZF_URL = "https://znajdzfizjoterapeute.pl/api/account/sso",
    EDM_URL = "https://app.finezjo.pl/api/account/sso",
    EDM_EN_URL = "https://en.finezjo.pl/api/account/sso",
    FIZJA_URL = "https://app.fizja.pl/"
}


// WEBPACK FOOTER //
// ./src/constants/AppUrls.ts